import { render, staticRenderFns } from "./Component-TaskFeedback.vue?vue&type=template&id=27be4e5e&"
import script from "./Component-TaskFeedback.vue?vue&type=script&lang=js&"
export * from "./Component-TaskFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports